import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";
import {
  BASE_URL,
  GET_ALL_MANAGER_STORES,
  GET_STORE_OPTIONS_DATA,
  UPDATE_STORE_OPTION,
  UPDATE_STORE_OPTIONS_DATA,
} from "../../../Constants/Config";
import { ciUrl } from "../../../Constants/nodeCi";

const initialState = {
  loading: false,
  storeoptionData: [],
  successMessage: "",
  error: "",
  storeLoadingStatus: true,
};

// Generate pening , fulfilled and rejected action type
export const fetchStoreSettingOptionData = createAsyncThunk(
  "StoreSettingOptionSlice/fetchStoreSettingOptionData.",
  async (data, { rejectWithValue }) => {
    const { token, ...dataNew } = data;
    try {
      const response = await axios.post(
        BASE_URL + GET_STORE_OPTIONS_DATA,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
      // throw new Error(error.response.data.message);
    }
  }
);

// UPDATE_STORE_OPTION
export const updateStoreOptionsDelivery = createAsyncThunk(
  "StoreSettingOptionSlice/updateStoreOptionsDelivery.",
  async (data, { rejectWithValue }) => {
    const { token, ...dataNew } = data;
    try {
      const response = await axios.post(
        BASE_URL + UPDATE_STORE_OPTION,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
      // throw new Error(error.response.data.message);
    }
  }
);

export const updateStoreOption = createAsyncThunk(
  "StoreSettingOptionSlice/updateStoreOption",
  async (data, { rejectWithValue }) => {
    const { token, ...dataNew } = data;
    try {
      const response = await axios.post(
        BASE_URL + UPDATE_STORE_OPTIONS_DATA,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      // throw new Error(error.response.data.message);
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const fetchStoreList = createAsyncThunk(
  "StoreSettingOptionSlice/fetchStoreList",
  async (data, { rejectWithValue }) => {
    const { token, cancelToken, ...dataNew } = data;
    try {
      const response = await axios.post(
        ciUrl(GET_ALL_MANAGER_STORES),
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          ...(cancelToken ? { cancelToken } : {}),
        }
      );
      return response?.data;
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ cancelled: true, message: "Request cancelled" });
      }
      // throw new Error(error.response.data.message);
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
const StoreSettingOptionSlice = createSlice({
  name: "StoreSettingOptionList",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchStoreSettingOptionData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchStoreSettingOptionData.fulfilled, (state, action) => {
      state.loading = false;
      state.storeoptionData = action.payload;
      state.error = "";
    });
    builder.addCase(fetchStoreSettingOptionData.rejected, (state, action) => {
      state.loading = false;
      state.storeoptionData = {};
      state.error = action.error.message;
    });
    builder.addCase(fetchStoreList.pending, (state) => {
      state.storeLoadingStatus = true;
    });
    builder.addCase(fetchStoreList.fulfilled, (state, action) => {
      state.storeLoadingStatus = false;
    });
    builder.addCase(fetchStoreList.rejected, (state, action) => {
      state.storeLoadingStatus = false;
    });
  },
});

export default StoreSettingOptionSlice.reducer;
